import React from 'react';

import dassaultSystemesImg from '../../images/dassault-systemes.png';
import siemensImg from '../../images/siemens.png';
import udemyImg from '../../images/udemy.png';
import sih2022Img from '../../images/sih-2022.jpeg';
import abuRobocon2022Img from '../../images/abu-robocon-2022.png';
import nitDurgapurImg from '../../images/nit-durgapur.jpeg';

import {
  CertificationAchievementsContainer,
  CertificationAchievementsH1,
  CertificationAchievementsWrapper,
  CertificationAchievementsCard,
  CertificationAchievementsH2,
  CertificationAchievementsP,
  GridContainer,
  CertificationAchievementsImg,
} from './CertificationAchievementsElements';

const CertificationAchievements = () => {
  return (
    <CertificationAchievementsContainer id="cert-achieve">
      <CertificationAchievementsWrapper>
        <CertificationAchievementsH1>
          Certifications
        </CertificationAchievementsH1>
        <GridContainer>
          <CertificationAchievementsCard
            as="a"
            href="https://drive.google.com/file/d/1hpIHQIfe5FUyavFD93qCIFTWCyDVJYuj/view?usp=drive_link"
            target="_blank"
          >
            <CertificationAchievementsImg
              src={dassaultSystemesImg}
              alt="Dassault Systemes"
              width={407}
              height={124}
            />
            <div>
              <CertificationAchievementsH2>
                Certified SolidWorks Additive Manufacturing Associate
              </CertificationAchievementsH2>
              <CertificationAchievementsP>
                Dassault Systemes
              </CertificationAchievementsP>
            </div>
          </CertificationAchievementsCard>
          <CertificationAchievementsCard
            as="a"
            href="https://drive.google.com/file/d/1AEamwWJ2XA33ckgz_WpRlIX-Nw7Umxk2/view?usp=drive_link"
            target="_blank"
          >
            <CertificationAchievementsImg
              src={siemensImg}
              alt="Siemens"
              width={566}
              height={89}
            />
            <div>
              <CertificationAchievementsH2>
                Certiﬁed Solid Edge Associate - 1
              </CertificationAchievementsH2>
              <CertificationAchievementsP>Siemens</CertificationAchievementsP>
            </div>
          </CertificationAchievementsCard>
          <CertificationAchievementsCard
            as="a"
            href="https://drive.google.com/file/d/1UEuFbX6ZfiPICmqjv2uwVmOqMwsTCyXe/view?usp=drive_link"
            target="_blank"
          >
            <CertificationAchievementsImg
              src={siemensImg}
              alt="Siemens"
              width={566}
              height={89}
            />
            <div>
              <CertificationAchievementsH2>
                Certiﬁed Solid Edge Associate - 2
              </CertificationAchievementsH2>
              <CertificationAchievementsP>Siemens</CertificationAchievementsP>
            </div>
          </CertificationAchievementsCard>
          <CertificationAchievementsCard
            as="a"
            href="https://drive.google.com/file/d/11tekRkPU7aTRksb-vwsxdV7RxXPYc6cG/view?usp=drive_link"
            target="_blank"
          >
            <CertificationAchievementsImg
              src={udemyImg}
              alt="Udemy"
              width={368}
              height={137}
            />
            <div>
              <CertificationAchievementsH2>
                Basic AutoCAD for Engineering Students
              </CertificationAchievementsH2>
              <CertificationAchievementsP>Udemy</CertificationAchievementsP>
            </div>
          </CertificationAchievementsCard>
          <CertificationAchievementsCard
            as="a"
            href="https://drive.google.com/file/d/1FQs4xmSni9QuizEaK4xuthy-fyYy-SB7/view?usp=drive_link"
            target="_blank"
          >
            <CertificationAchievementsImg
              src={udemyImg}
              alt="Udemy"
              width={368}
              height={137}
            />
            <div>
              <CertificationAchievementsH2>
                AP Environmental Science
              </CertificationAchievementsH2>
              <CertificationAchievementsP>Udemy</CertificationAchievementsP>
            </div>
          </CertificationAchievementsCard>
        </GridContainer>
        <CertificationAchievementsH1>Achievements</CertificationAchievementsH1>
        <GridContainer>
          <CertificationAchievementsCard
            as="a"
            href="https://drive.google.com/file/d/1532_N5nwEaGFLV8w2_7hk6OXtSja5rOS/view?usp=sharing"
            target="_blank"
          >
            <CertificationAchievementsImg
              src={sih2022Img}
              alt="Smart India Hackathon - Hardware Edition 2022"
              width={334}
              height={151}
            />
            <div>
              <CertificationAchievementsH2>
                Winner at Smart India Hackathon - Hardware Edition 2022
              </CertificationAchievementsH2>
              <CertificationAchievementsP>
                Govt. of India | Ministry of Science and Technology
              </CertificationAchievementsP>
            </div>
          </CertificationAchievementsCard>
          <CertificationAchievementsCard
            as="a"
            href="https://drive.google.com/file/d/1xhi9akgHNDrLzSi7JkzVuJo3GVteNZxS/view?usp=sharing"
            target="_blank"
          >
            <CertificationAchievementsImg
              src={abuRobocon2022Img}
              alt="ABU Robocon Competition - 2022"
              width={292}
              height={182}
            />
            <div>
              <CertificationAchievementsH2>
                AIR 5 at DD National ABU Robocon Competition - 2022
              </CertificationAchievementsH2>
              <CertificationAchievementsP>
                ABU Robocon | IIT Delhi
              </CertificationAchievementsP>
            </div>
          </CertificationAchievementsCard>
          <CertificationAchievementsCard
            as="a"
            href="https://drive.google.com/file/d/1z3ZJ7WPMacn0d95E6Xvnlx5nV9ALi_oz/view?usp=sharing"
            target="_blank"
          >
            <CertificationAchievementsImg
              src={abuRobocon2022Img}
              alt="ABU Robocon Competition - 2022"
              width={292}
              height={182}
            />
            <div>
              <CertificationAchievementsH2>
                Best Software Award at DD National ABU Robocon Competition -
                2022
              </CertificationAchievementsH2>
              <CertificationAchievementsP>
                Addverb Technologies
              </CertificationAchievementsP>
            </div>
          </CertificationAchievementsCard>
          <CertificationAchievementsCard
            as="a"
            href="https://drive.google.com/file/d/1DfynlU-OOmOvwSLqQkWdt3uo0n-VNj1-/view?usp=sharing"
            target="_blank"
          >
            <CertificationAchievementsImg
              src={nitDurgapurImg}
              alt="NIT Durgapur"
              width={220}
              height={215}
            />
            <div>
              <CertificationAchievementsH2>
                Second Position at Onspot Hackathon
              </CertificationAchievementsH2>
              <CertificationAchievementsP>
                NIT Durgapur
              </CertificationAchievementsP>
            </div>
          </CertificationAchievementsCard>
        </GridContainer>
      </CertificationAchievementsWrapper>
    </CertificationAchievementsContainer>
  );
};

export default CertificationAchievements;
